import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import Navbar from './components/navbar/navbar';
import Footer from './components/footer/footer';
import ScrollToTop from './components/scrollToTop/scrollToTop';
import Loader from './components/loader/loader';

const Home = lazy(() => import('./pages/home/home'));
const History = lazy(() => import('./pages/history/history'));
const Teams = lazy(() => import('./pages/teams/teams'));
const Staff = lazy(() => import('./pages/staff/staff'));
const Camp = lazy(() => import('./pages/camp/camp'));
const Support = lazy(() => import('./pages/support/support'));
const IgPosts = lazy(() => import('./pages/igPosts/igPosts'));
const NotFound = lazy(() => import('./pages/notFound/notFound'));

function App() {
  return (
    <Router>
      <Navbar />
      
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/historia" element={<History />} />
          <Route path="/druzyny" element={<Teams />} />
          <Route path="/komenda" element={<Staff />} />
          {/* <Route path="/oboz" element={<Camp />} />  */}
          <Route path="/wesprzyj" element={<Support />} />
          <Route path="/posty" element={<IgPosts />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>

      <ScrollToTop />
      <Footer />
      <script src="https://elfsightcdn.com/platform.js" async></script>
      <div class="elfsight-app-aa4ff35e-2c91-4aef-b6c9-5d9c5f73c72c" data-elfsight-app-lazy></div>
    </Router>
  );
}

export default App;